var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('service-info',{attrs:{"service":_vm.service}}),_c('deployments',{attrs:{"service":_vm.service}}),_c('service-plans',{attrs:{"plans":_vm.service.plans}}),_c('service-clusters',{attrs:{"clusters":_vm.service.clusters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }